import { Badge, Card, Grid, Group, Text, ThemeIcon } from '@mantine/core';
import { IconActivity, IconClock, IconDatabase, IconServer } from '@tabler/icons-react';

interface SessionStatsCardsProps {
  isSessionActive: boolean;
  sessionDurationMinutes: number;
  requestsCount: number;
}

export const SessionStatsCards = ({ isSessionActive, sessionDurationMinutes, requestsCount }: SessionStatsCardsProps) => {
  return (
    <Grid gutter="md">
      <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Group justify="space-between" mb="xs">
            <Text size="sm" fw={500} c="dimmed">
              Session Status
            </Text>
            <ThemeIcon color={isSessionActive ? 'green' : 'red'} variant="light" radius="xl" size="lg">
              <IconActivity size={20} />
            </ThemeIcon>
          </Group>
          <Badge color={isSessionActive ? 'green' : 'red'} size="xl" variant="dot">
            {isSessionActive ? 'Active' : 'Inactive'}
          </Badge>
        </Card>
      </Grid.Col>

      <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Group justify="space-between" mb="xs">
            <Text size="sm" fw={500} c="dimmed">
              Session Duration
            </Text>
            <ThemeIcon color="blue" variant="light" radius="xl" size="lg">
              <IconClock size={20} />
            </ThemeIcon>
          </Group>
          <Text size="xl" fw={700}>
            {sessionDurationMinutes} min
          </Text>
        </Card>
      </Grid.Col>

      <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Group justify="space-between" mb="xs">
            <Text size="sm" fw={500} c="dimmed">
              Requests Logged
            </Text>
            <ThemeIcon color="violet" variant="light" radius="xl" size="lg">
              <IconServer size={20} />
            </ThemeIcon>
          </Group>
          <Text size="xl" fw={700}>
            {requestsCount}
          </Text>
        </Card>
      </Grid.Col>

      <Grid.Col span={{ base: 12, sm: 6, md: 3 }}>
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Group justify="space-between" mb="xs">
            <Text size="sm" fw={500} c="dimmed">
              DB Changes
            </Text>
            <ThemeIcon color="orange" variant="light" radius="xl" size="lg">
              <IconDatabase size={20} />
            </ThemeIcon>
          </Group>
          <Text size="xl" fw={700}>
            {isSessionActive ? 'Tracking' : 'Paused'}
          </Text>
        </Card>
      </Grid.Col>
    </Grid>
  );
};
